import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  DeltaHedgeAccountsUploadFileMode,
  IAddDeltaHedgeAccount,
  IInsValues,
} from "../../Interfaces/deltaHedgeAccounts";

interface ISlice {
  addEditFormValues: IAddDeltaHedgeAccount;
  accountTableRefetchFlag: boolean;
  addEditModalFlag: boolean;
  insValues: IInsValues[];
  isEdit?: boolean;
  mode: DeltaHedgeAccountsUploadFileMode;
}

const initialState: ISlice = {
  addEditFormValues: {} as IAddDeltaHedgeAccount,
  accountTableRefetchFlag: false,
  addEditModalFlag: false,
  insValues: [],
  isEdit: false,
  mode: DeltaHedgeAccountsUploadFileMode.UpdateAll,
};

const DeltaHedgeSettingsSlice = createSlice({
  name: "deltaHedgeAccounts",
  initialState,
  reducers: {
    addEditDeltaHedgeAccountFormValuesChangeHandler: (
      store,
      action: PayloadAction<{ name: string; value: any }>
    ) => {
      store.addEditFormValues = {
        ...store.addEditFormValues,
        [action.payload.name]: action.payload.value,
      };
    },
    setAddEditDeltaHedgeAccountsFormValues: (
      store,
      action: PayloadAction<IAddDeltaHedgeAccount>
    ) => {
      store.addEditFormValues = action.payload;
    },
    setDeltaHedgeAccountFlag: (store, action: PayloadAction<boolean>) => {
      store.accountTableRefetchFlag = action.payload;
    },
    setHeltaHedgeAccountsAddEditModalFlag: (
      store,
      action: PayloadAction<boolean>
    ) => {
      store.addEditModalFlag = action.payload;
    },
    setDeltaHedgeAccountsInsValues: (
      store,
      action: PayloadAction<IInsValues[]>
    ) => {
      store.insValues = action.payload;
    },
    setDeltaHedgeAccountEditFlag: (store, action: PayloadAction<boolean>) => {
      store.isEdit = action.payload;
    },
    setDeltaHedgeAccountMode: (
      store,
      action: PayloadAction<DeltaHedgeAccountsUploadFileMode>
    ) => {
      store.mode = action.payload;
    },
  },
});

export const {
  addEditDeltaHedgeAccountFormValuesChangeHandler,
  setAddEditDeltaHedgeAccountsFormValues,
  setDeltaHedgeAccountFlag,
  setHeltaHedgeAccountsAddEditModalFlag,
  setDeltaHedgeAccountsInsValues,
  setDeltaHedgeAccountEditFlag,
  setDeltaHedgeAccountMode,
} = DeltaHedgeSettingsSlice.actions;
export default DeltaHedgeSettingsSlice.reducer;
